export const allBusinessNameTableHeader = ['Entity Official Names', 'Source']

export const addAddressesHeader = ['Address', 'Source']
